import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { FC, ReactNode } from 'react';

import { MESSAGE_CONTENT_TYPE_ATTRIBUTE, MessageContentType } from '@gem/utils';

import { TextRenderer } from 'APP/components/TextRenderer/TextRenderer';
import { QuotedSelectionHighlight } from 'APP/main/ChatView/Messages/Message/components/QuoteSelectionHighlight/QuotedSelectionHighlight';
import { MessageViewPageType } from 'APP/main/ChatView/Messages/Messages.types';
import { ChatMessage } from 'STORE/Messages/Message/ChatMessage/ChatMessage';

import { MessageLayout } from '../../MessageLayout/MessageLayout';
import StatusBar from '../components/StatusBar';
import { ThreadButton } from '../components/ThreadButton/ThreadButton';
import Header from './Header';
import { useStickerBubblePresenter } from './StickerBubble.presenter';
import styles from './styles.m.css';

interface StickerBubbleProps {
  message: ChatMessage;
  children: ReactNode;
  messageViewPageType: MessageViewPageType;
  isView: boolean;
}

export const StickerBubble: FC<StickerBubbleProps> = observer((props) => {
  const { message, children, messageViewPageType, isView } = props;
  const presenter = useStickerBubblePresenter(message);
  const { comment } = message.payload;

  const classes = classNames(styles.bubble, {
    [styles.myBubble]: message.fromMe,
  });

  return (
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    <MessageLayout
      message={message}
      className={classes}
      containerClassName={styles.container}
      messageViewPageType={messageViewPageType}
      isView={isView}
    >
      {presenter.isExistHeader && (
        <Header
          message={message}
          isShowForward={presenter.isShowForward}
        />
      )}
      <div className={styles.content}>
        {children}
        {!comment && (
          <StatusBar
            className={styles.statusBar}
            message={message}
            viewsClassName={styles.views}
            fixedColor={true}
          />
        )}
      </div>
      {comment && comment.length && (
        <div className={styles.comment}>
          <div
            className={styles.commentText}
            {...{ [MESSAGE_CONTENT_TYPE_ATTRIBUTE]: MessageContentType.Text }}
          >
            <QuotedSelectionHighlight
              highlightedText={message.highlightedText}
              originalText={comment}
              groupId={message.groupId}
            >
              <TextRenderer>{comment}</TextRenderer>
            </QuotedSelectionHighlight>
          </div>
          <StatusBar
            message={message}
            className={styles.commentedStatusBar}
            viewsClassName={styles.views}
            fixedColor={true}
          />
        </div>
      )}
      <ThreadButton message={message} />
    </MessageLayout>
  );
});
